import React, { useEffect } from 'react';
import { Result, Button, Card, Typography, Space } from 'antd';
import { ExclamationCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/Login.css';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph, Text } = Typography;

const AuthError = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['auth']);
  
  // 从URL参数中获取错误信息
  const searchParams = new URLSearchParams(location.search);
  const errorType = searchParams.get('error') || 'unknown';
  const errorMessage = searchParams.get('message') || '';
  
  // 根据错误类型显示不同的信息
  const getErrorInfo = () => {
    switch (errorType) {
      case 'email_already_registered':
        return {
          title: t('auth:auth_error.email_already_registered.title'),
          subtitle: t('auth:auth_error.email_already_registered.subtitle'),
          description: t('auth:auth_error.email_already_registered.description'),
          action: t('auth:auth_error.email_already_registered.action'),
          suggestions: t('auth:auth_error.email_already_registered.suggestions', { returnObjects: true })
        };
      case 'auth_failed':
        return {
          title: t('auth:auth_error.auth_failed.title'),
          subtitle: t('auth:auth_error.auth_failed.subtitle'),
          description: t('auth:auth_error.auth_failed.description'),
          action: t('auth:auth_error.auth_failed.action'),
          suggestions: t('auth:auth_error.auth_failed.suggestions', { returnObjects: true })
        };
      case 'no_token':
        return {
          title: t('auth:auth_error.no_token.title'),
          subtitle: t('auth:auth_error.no_token.subtitle'),
          description: t('auth:auth_error.no_token.description'),
          action: t('auth:auth_error.no_token.action'),
          suggestions: t('auth:auth_error.no_token.suggestions', { returnObjects: true })
        };
      case 'use_google_login':
        return {
          title: t('auth:auth_error.use_google_login.title'),
          subtitle: t('auth:auth_error.use_google_login.subtitle'),
          description: t('auth:auth_error.use_google_login.description'),
          action: t('auth:auth_error.use_google_login.action'),
          suggestions: t('auth:auth_error.use_google_login.suggestions', { returnObjects: true })
        };
      case 'login_failed':
        return {
          title: t('auth:auth_error.login_failed.title'),
          subtitle: t('auth:auth_error.login_failed.subtitle'),
          description: errorMessage || t('auth:auth_error.login_failed.description_fallback'),
          action: t('auth:auth_error.login_failed.action'),
          suggestions: t('auth:auth_error.login_failed.suggestions', { returnObjects: true })
        };
      default:
        return {
          title: t('auth:auth_error.unknown.title'),
          subtitle: t('auth:auth_error.unknown.subtitle'),
          description: errorMessage || t('auth:auth_error.unknown.description_fallback'),
          action: t('auth:auth_error.unknown.action'),
          suggestions: t('auth:auth_error.unknown.suggestions', { returnObjects: true })
        };
    }
  };
  
  const errorInfo = getErrorInfo();
  
  useEffect(() => {
    // 设置页面标题
    document.title = `${errorInfo.title} - ClipAI`;
  }, [errorInfo.title]);
  
  const handleBackToLogin = () => {
    navigate('/login');
  };
  
  return (
    <div className="login-container">
      <div className="login-form-container">
        <Card className="auth-error-card" style={{ maxWidth: 600, margin: '0 auto' }}>
          <Result
            icon={<ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />}
            title={
              <Title level={2} style={{ color: '#ff4d4f', marginBottom: 8 }}>
                {errorInfo.title}
              </Title>
            }
            subTitle={
              <Text type="secondary" style={{ fontSize: '16px' }}>
                {errorInfo.subtitle}
              </Text>
            }
            extra={
              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <div style={{ textAlign: 'left' }}>
                  <Paragraph style={{ marginBottom: 16 }}>
                    {errorInfo.description}
                  </Paragraph>
                  
                  <Text strong style={{ display: 'block', marginBottom: 12 }}>
                    {errorInfo.action}
                  </Text>
                  
                  <ul style={{ paddingLeft: 20, marginBottom: 24 }}>
                    {errorInfo.suggestions.map((suggestion, index) => (
                      <li key={index} style={{ marginBottom: 8 }}>
                        <Text>{suggestion}</Text>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <Space size="middle" wrap>
                  <Button 
                    type="primary" 
                    icon={<ArrowLeftOutlined />}
                    onClick={handleBackToLogin}
                    size="large"
                  >
                    {t('auth:auth_error.back_login')}
                  </Button>
                </Space>
              </Space>
            }
          />
        </Card>
      </div>
    </div>
  );
};

export default AuthError;
